import { CommonModule, DecimalPipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { AccessModule } from '@app/access/access.module';
import { TimeagoModule } from 'ngx-timeago';

import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { ValidationIconComponent } from '@app/pages/form/save-form/validation-icon/validation-icon.component';
import { DetailInfoTableViewComponent } from './detail-info-table-view/detail-info-table-view.component';
import { DropdownContainerComponent } from './dropdown-container/dropdown-container.component';
import { DropdownItemComponent } from './dropdown-item/dropdown-item.component';
import { Ng2DeepSearchPipe } from './pipe/deep.filter';
import { LimitToPipe } from './pipe/limit-to.pipe';
import { SortableHeader } from './search-sort/sortable.directive';
import { BackButtonComponent } from './ui/back-button/back-button.component';
import { UIModule } from './ui/ui.module';
import { WidgetModule } from './widget/widget.module';
import { FilterPipe } from './pipe/filter.pipe';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { HoursMinutesPipe } from './pipe/hours-minutes.pipe';
import { TermPipe } from './pipe/term.pipe';
import { ProcessingButtonDirective } from './ui/processing-button.directive';
import { BalancedTabsDirective } from './ui/balanced-tabs.directive';

@NgModule({
  declarations: [
    DetailInfoTableViewComponent,
    DropdownContainerComponent,
    DropdownItemComponent,
    ValidationIconComponent,
    SortableHeader,
    LimitToPipe,
    FilterPipe
  ],
  imports: [
    CommonModule,
    FormsModule,
    RouterModule,
    UIModule,
    WidgetModule,
    AccessModule,
    TimeagoModule,
    BsDatepickerModule.forRoot(),
    HoursMinutesPipe,
    TermPipe,
    ProcessingButtonDirective,
    BalancedTabsDirective
  ],
  exports: [
    CommonModule,
    FormsModule,
    RouterModule,
    AccessModule,
    WidgetModule,
    UIModule,
    TimeagoModule,
    SortableHeader,
    DetailInfoTableViewComponent,
    DropdownContainerComponent,
    DropdownItemComponent,
    BackButtonComponent,
    ValidationIconComponent,
    DecimalPipe,
    LimitToPipe,
    FilterPipe,
    HoursMinutesPipe,
    TermPipe,
    ProcessingButtonDirective,
    BalancedTabsDirective,
    BsDatepickerModule,
  ],
  providers: [
    SortableHeader, DecimalPipe, Ng2DeepSearchPipe
  ]
})

export class SharedModule { }
